import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '@/views/home.vue'
import HomeIndexView from '@/views/index/index.vue'
import HelpView from '@/views/help/index.vue'
import AboutView from '@/views/about/index.vue'
import SafeView from '@/views/safe/index.vue'
import DownView from '@/views/down/index.vue'
import InfoView from '@/views/info/index.vue'
import privacyPolicy from '@/views/privacyPolicy/index.vue'
import userAgreement from '@/views/userAgreement/index.vue'
import InstallGuideView from '@/views/installGuide/mobile/index.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        children: [
            {
                path: '/',
                name: 'index',
                component: HomeIndexView,
            },
            {
                path: '/help',
                name: 'help',
                component: HelpView,
            },
            {
                path: '/info',
                name: 'info',
                component: InfoView,
            },
            {
                path: '/about',
                name: 'about',
                component: AboutView,
            },
            {
                path: '/safe',
                name: 'safe',
                component: SafeView,
            },
            {
                path: '/down',
                name: 'down',
                component: DownView,
            }
        ]
    },
    {
        path: '/privacyPolicy',
        name: 'privacyPolicy',
        component: privacyPolicy,
    },
    {
        path: '/userAgreement',
        name: 'userAgreement',
        component: userAgreement,
    },
    {
        path: '/installGuide', // 新增
        name: 'installGuide',
        component: InstallGuideView,
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
